import type { GetServerSidePropsContext } from 'next';

export const getClientIp = (context: GetServerSidePropsContext): string => {
  const realIp = context.req.headers['x-real-ip'];
  const clientIp = realIp || '';

  return typeof clientIp === 'string' ? clientIp : '';
};
